import { useState } from 'react';
import usePost from '../../Hooks/usePost';
import API_ENDPOINTS from '../../Config/api';
import ClipLoader from 'react-spinners/ClipLoader';
import SearchBar from '../UI/Searchbar'
import ToggleButton from '../UI/ToggleButton';
import { useTranslation } from 'react-i18next';

export default function ListAziendeTable({

  data = [],
  setData,
  refetchData

}) {

  const [search, setSearch] = useState('');

  const filteredData = data?.aziende.filter((item) => {
    const s = search.toLowerCase();
    return (item.nome ?? '').toLowerCase().includes(s);
  });


  return (
    <div>
      <div className="mb-4">
        <SearchBar
          search={search}
          setSearch={setSearch}
          placeholder={null}
        />
      </div>

      <div className="flex flex-col h-[32rem]">
        <div className="flex-1 min-h-0 overflow-x-auto overflow-y-auto [scrollbar-gutter:stable] border-[#D1D5DB] border rounded">
          <table className="w-full min-w-[800px] table-auto text-sm text-slate-200 border-collapse">
            <colgroup>
              <col className="w-[25%]" />
              <col className="w-[9%]" />
              <col className="w-[9%]" />
              <col className="w-[9%]" />
              <col className="w-[9%]" />
              <col className="w-[9%]" />
              <col className="w-[15%]" />
              <col className="w-[15%]" />
            </colgroup>

            <thead className="text-black text-xs sm:text-sm sticky top-0 z-10 bg-[#F3F4F7]">
              <tr>
                <th className="px-2 sm:px-3 py-3 sm:py-5 text-left font-medium whitespace-nowrap">Azienda</th>
                <th className="px-2 sm:px-3 py-3 sm:py-5 text-left font-medium whitespace-nowrap">Endpoint <br /> attivi</th>
                <th className="px-2 sm:px-3 py-3 sm:py-5 text-left font-medium whitespace-nowrap">Malware Rate <br /> File Angel</th>
                <th className="px-2 sm:px-3 py-3 sm:py-5 text-left font-medium whitespace-nowrap">Protezione <br />Browsing Angel</th>
                <th className="px-2 sm:px-3 py-3 sm:py-5 text-left font-medium whitespace-nowrap">Copertura <br />Nis2</th>
                <th className="px-2 sm:px-3 py-3 sm:py-5 text-left font-medium whitespace-nowrap">Cyber<br /> risk Score</th>
                <th className="px-2 sm:px-3 py-3 sm:py-5 text-center font-medium whitespace-nowrap">Visibilità</th>
                <th className="px-2 sm:px-3 py-3 sm:py-5 text-center font-medium whitespace-nowrap"></th>
              </tr>
            </thead>

            <tbody>
              {filteredData && filteredData.length > 0 ? (
                filteredData.map((item, i) => {
                  // if (i === 0)
                  return (
                    <Row key={item.id} item={item} refetchData={refetchData} />
                  )
                }
                )
              ) : (
                <tr>
                  <td colSpan={8} className="text-center py-6 text-slate-400">
                    Nessuna azienda trovata
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}






function Row({

  item,
  refetchData

}) {

  const { postData, loading } = usePost();
  const [verifying, setVerifying] = useState(false);

  const handleSsoLogin = async (row) => {
    try {
      const res = await postData(API_ENDPOINTS.tokenSso, {
        target_azienda_id: row.id,
      });
      if (res?.redirect_url && res?.token) {
        const hostname = window.location.hostname;
        const frontendUrl = process.env.REACT_APP_SMB_FRONTEND_URL || `${window.location.protocol}//${hostname}`;
        const redirectUrl = res.redirect_url.replace(/https?:\/\/[^\/]+/, frontendUrl);
        const targetOrigin = new URL(redirectUrl).origin;

        // Open the SSO page without any token in the URL
        const child = window.open(redirectUrl, '_blank');

        // When the child signals it's ready, send the token via postMessage
        // (the token never appears in the URL, logs, or Referer headers)
        const onReady = (event) => {
          if (event.source !== child) return;
          if (event.data !== 'sso-ready') return;
          child.postMessage({ type: 'sso-token', token: res.token }, targetOrigin);
          window.removeEventListener('message', onReady);
        };
        window.addEventListener('message', onReady);
        // Cleanup if the child never signals (e.g. popup blocked)
        setTimeout(() => window.removeEventListener('message', onReady), 5 * 60 * 1000);
      } else {
        alert('Nessun URL ricevuto');
      }
    } catch (err) {
      console.error('Errore SSO:', err);
      alert('Errore durante il login SSO');
    }
  };

  const handleBellClick = async (row) => {
    try {
      // First, mark as verified for MSSP (acknowledge alerts)
      await postData(API_ENDPOINTS.listaAziendeMSSP, {
        azienda_id: row.id,
        visibile_a_azienda: !!row.visibile_a_azienda,
        mssp_verified: true
      }, 'PATCH');
    } catch (err) {
      console.error('Errore aggiornamento mssp_verified:', err);
      // proceed anyway to open SSO
    }
    // then perform SSO login (open company)
    handleSsoLogin(row);
  };

  const handleToggleVisibility = async (aziendaId, currentVisibility) => {
    try {
      const res = await postData(API_ENDPOINTS.listaAziendeMSSP, {
        azienda_id: aziendaId,
        visibile_a_azienda: !currentVisibility
      }, 'PATCH');
      if (res) {
        refetchData(); // Ricarica i dati
      }
    } catch (err) {
      console.error('Errore toggle visibilità:', err);
      alert('Errore durante l\'aggiornamento della visibilità');
    }
  };

  const handleVerifyCompany = async (aziendaId, currentlyVerified, currentVisibility=false) => {
    // backend requires azienda_id and visibile_a_azienda in the PATCH payload.
    // We include those and also send mssp_verified for future-proofing if supported server-side.
    try {
      setVerifying(true);
      const payload = {
        azienda_id: aziendaId,
        visibile_a_azienda: !!currentVisibility,
        mssp_verified: !currentlyVerified
      };
      const res = await postData(API_ENDPOINTS.listaAziendeMSSP, payload, 'PATCH');
      if (res) {
        refetchData();
      }
    } catch (err) {
      console.error('Errore durante la verifica MSSP:', err);
      alert('Impossibile aggiornare lo stato di verifica');
    } finally {
      setVerifying(false);
    }
  };


  return (
    <>
      <tr className=" text-black border-white border-b-4 bg-[#E3E3E3]">

        {/* Ragione sociale */}
        <td className="px-3 py-3">
          <p className="font-semibold leading-tight">
            {item.nome ?? "--"}
          </p>
        </td>

        {/* Endpoint attivi */}
        <td className="px-3 py-3 text-center tabular-nums">
          {`${item.endpoint_attivi} su ${item.endpoint_totali}` ?? "--"}
        </td>

        {/* Malware rate File Angel */}
        <td className="px-3 py-3 text-center tabular-nums">
          {`${item.malware_rate}%` ?? "--"}
        </td>

        {/* Protezione Browsing Angel */}
        <td className="px-3 py-3 text-center tabular-nums">
          {`${item.browsing_protezione}%` ?? "--"}
        </td>

        {/* Copertura Nis2 */}
        <td className="px-3 py-3 text-center tabular-nums">
          {`${item.nis2_risk_score}%` ?? "--"}
        </td>

        {/* Cyber Risk Score */}
        <td className="px-3 py-3 text-center tabular-nums">
          {`${item.minacce_percentuale}%` ?? "--"}
        </td>

        {/* Toggle Visibilità */}
        <td className="px-3 py-3 text-center">
          <ToggleButton
            checked={item.visibile_a_azienda || false}
            onToggle={() => handleToggleVisibility(item.id, item.visibile_a_azienda)}
          />
        </td>

        <td className="px-3 py-3 text-center tabular-nums flex items-center justify-center gap-2">
          {/* Notification bell: red = new incidents, orange = verified but present, gray = none */}
          <button
            onClick={() => handleBellClick(item)}
            className={`p-2 rounded-full flex items-center justify-center focus:outline-none transition-colors ${
              (() => {
                if (item.has_new_incidents) return 'bg-red-600 text-white';
                if (item.has_present_incidents && item.mssp_verified) return 'bg-orange-500 text-white';
                return 'bg-gray-200 text-gray-700';
              })()
            }`}
            title={(() => {
              if (item.has_new_incidents) return "Nuovi incidenti rilevati (clicca per accedere all'azienda)";
              if (item.has_present_incidents && item.mssp_verified) return "Incidenti verificati ma ancora presenti";
              return 'Accedi all\'azienda';
            })()
            }
            disabled={verifying}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6 6 0 10-12 0v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
            </svg>
          </button>

          <button 
            className={`w-[75px] h-[35px] rounded border transition inline-flex items-center justify-center ${
              loading
                ? "bg-gray-300 text-gray-500 cursor-not-allowed" 
                : "hover:bg-blue-600 bg-blue-500 text-white"
            }`}
            onClick={() => handleSsoLogin(item)}
            disabled={loading}
            title="Accedi all'azienda"
          >
            {loading ? <ClipLoader size={16} color="currentColor" /> : "Accedi"}
          </button>
        </td>
      </tr>
    </>
  );
}